/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import * as React from "react";
import Box from "@mui/material/Box";
import TuneIcon from "@mui/icons-material/Tune";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { Checkbox, Grid, Typography } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import classes from "./TenantUserPage.module.css";
import {
  selectedApplications,
  sendFilteredData,
} from "../../store/Tenant/tenant-actions";
import { selectedRoles, setFilteredUsers } from "../../store/User/user-actions";
import { User } from "oidc-react";

type Anchor = "top" | "left" | "bottom" | "filter";

export default function TemporaryDrawerforUser({
  isFilterDisabled,
  filteringCritera,
  onFilteringCriteriaChange,
}: {
  isFilterDisabled?: boolean;
  filteringCritera: Array<string>;
  onFilteringCriteriaChange: any;
}) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    filter: false,
  });

  const [selectedOptions, setSelectedOptions] =
    useState<Array<string>>(filteringCritera);

  const ListofRoles = useSelector(
    (state: RootState) => state.user.rolestoFilterTenants
  );
  //on change of user filter
  // istanbul ignore next
  const handleCheckboxChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  //on cancel of filter tab
  // istanbul ignore next
  const handleCancel = () => {
    setSelectedOptions(filteringCritera);
    setState({ top: false, left: false, bottom: false, filter: false });
  };

  //on clear of user filter
  // istanbul ignore next
  const handleClear = () => {
    setSelectedOptions([]);
  };

  //on submit of submit
  // istanbul ignore next
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onFilteringCriteriaChange(selectedOptions);

    setState({ ...state, filter: false });
  };

  const toggleDrawer = (anchor: Anchor, open: boolean) => () => {
    setState({ ...state, [anchor]: open, filter: true });
  };

  // Set selectedOptions to filteringCriteria whenever filteringCriteria changes
  useEffect(() => {
    setSelectedOptions(filteringCritera);
  }, [filteringCritera]);

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );

  return (
    <div>
      {(["filter"] as const).map((anchor) => (
        <div key={anchor}>
          <Button
            disabled={isFilterDisabled}
            data-testid="filter-Button"
            startIcon={
              <TuneIcon
                sx={{
                  transform: "rotate(90deg)",
                  width: "0.7rem",
                  height: "0.7rem",
                }}
              />
            }
            sx={{
              color: "#F0F0F0",
              background: "#707070",
              border: "1px solid #707070",
              fontSize: "0.7rem",
              height: "3.5vh",
              width: "auto",
              paddingRight: "2vw",
              paddingLeft: "2vw",
            }}
            onClick={toggleDrawer(anchor, true)}
          >
            <div style={{ textTransform: "capitalize" }}>{anchor}</div>
          </Button>
          <Drawer
            anchor={"right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, true)}
            variant="temporary"
          >
            <Box
              sx={{
                color: "#F0F0F0",
                padding: "1vh",
                backgroundColor: "#272727",
                height: "100%",
                marginTop: "4vh",
                width: "25vw",
              }}
            >
              <Grid container direction="column">
                <Grid container direction="row">
                  <Grid item width="50%" className={classes.filterHeadingGrid}>
                    <Typography className={classes.filterHeading}>
                      Filter
                    </Typography>
                  </Grid>

                  <Grid container justifyContent="flex-end" width="50%">
                    <Button
                      sx={{
                        width: "0.5vw",
                        justifyContent: "flex-end",
                      }}
                      onClick={handleCancel}
                    >
                      <CloseIcon sx={{ color: "#F0F0F0" }} />
                    </Button>
                  </Grid>
                </Grid>
                <Grid container direction="row">
                  <Grid
                    item
                    sx={{
                      padding: "0.8vh",
                      paddingBottom: "0.4vh",
                      paddingTop: "1.5vh",
                      width: "50%",
                    }}
                    className={classes.filterby}
                  >
                    Filter By
                  </Grid>
                  <Grid
                    container
                    justifyContent="flex-end"
                    width="50%"
                    sx={{
                      padding: "1vh",
                    }}
                  >
                    <Button
                      sx={{ padding: 0 }}
                      onClick={handleClear}
                      startIcon={<RestartAltIcon />}
                      className={classes.clearall}
                    >
                      Clear all
                    </Button>
                  </Grid>
                </Grid>
                <Grid item padding={2} className={classes.subHeadingFilter}>
                  Roles
                </Grid>
              </Grid>

              <form onSubmit={handleSubmit}>
                {ListofRoles.map((option: any) => (
                  <div key={option.role.name} className={classes.optionsCheck}>
                    <Checkbox
                      checked={selectedOptions.includes(option.role.name)}
                      onChange={() => handleCheckboxChange(option.role.name)}
                      inputProps={{ "aria-label": option.role.name }}
                      className={classes.Check}
                    />
                    {option.role.name}
                    {"("} {option.count} {")"}
                  </div>
                ))}
                <Grid
                  container
                  justifyContent="flex-end"
                  direction="row"
                  className={classes.filterButtonGrid}
                  sx={{
                    bottom: "4vh",
                    WebkitAlignContent: "unset",
                  }}
                >
                  <Grid item width="50%">
                    <Button
                      className={classes.cancelButton}
                      onClick={handleCancel}
                      sx={{ margin: "0.5vw", marginLeft: "2vw" }}
                      data-testid="cancelButtonUserFilter"
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid container width="50%" justifyContent="flex-end">
                    <Button
                      type="submit"
                      className={classes.filterButtonShow}
                      sx={{ margin: "0.5vw" }}
                    >
                      Show results
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
            {list(anchor)}
          </Drawer>
        </div>
      ))}
    </div>
  );
}
